import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { CommonHeaderService } from './common-header.service'
import { Injectable } from '@angular/core'

@Injectable()
export class AppendCommonHeaders implements HttpInterceptor {
  constructor(private readonly commonHeaderService: CommonHeaderService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const headers = this.commonHeaderService.getAll()
    const clonedReq = req.clone({
      headers: new HttpHeaders(headers),
    })
    return next.handle(clonedReq)
  }
}
